<script>
    import Button from "../ui_elements/Button.svelte";
    import { push } from "svelte-spa-router";
    import { handleLogin, isLoggedIn } from "../utility.js";
    import PageBox from "../layouts/PageBox.svelte";
    import { onMount } from 'svelte';
    import ContentBox from "../layouts/ContentBox.svelte";

    let pageTitle = "Authentifizierung";
    let description = "Bitte gebe deinen Username und Authentifizierungscode an.";

    let username = "";
    let authenticationCode = "";
    let information = "";

    let redirectTo = "";
    
    onMount(async () => {
        // redirect if user is already logged in
        const loggedIn = await isLoggedIn();
        if (loggedIn) {
            push('/');
        }

        // save redirect to protected page user originally wanted to access
        const hash = window.location.hash;
        if (hash.indexOf('?') !== -1){ 
            const urlParams = new URLSearchParams(hash.split('?')[1]);
            redirectTo = urlParams.get('redirectTo') || '/';
            information = urlParams.get('m') || '';
        }

        if (information == "logout") {
            information = "Du wurdest erfolgreich ausgeloggt.";
        }
        if (information == "protected") {
            information = "Die angefragte Seite ist geschützt. Bitte logge dich ein, um Zugriff zu erhalten!";
        }
    });


    async function handleKeyDown(event) {
        if (event.key === 'Enter') {
            handleLoginClick();
        }
    }

    async function handleLoginClick() {
        try {
            await handleLogin(username, authenticationCode, redirectTo);
        } catch (err) {
            information = err.message;
        }

    }
</script>

        
<PageBox {pageTitle} {description}>        
    <ContentBox w="1/3" minWidth = "300px">
        {#if information != ""}
            <div class="mb-4 p-4 bg-accent-light border border-accent-border text-accent-text rounded">
                {information}
            </div>            
        {/if}

        <div class="mb-6">
            <label for="username" class="block text-sm font-medium leading-6">Username</label>
            <input id="username" bind:value={username} placeholder="Dein Nutzername" type="text" autocomplete="username" required class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-accent-border sm:text-sm sm:leading-6" on:keydown={handleKeyDown}>
        </div>
    
        <div class="mb-6">
            <label for="authenticationCode" class="block text-sm font-medium leading-6">Authentifizierungscode</label>
            <input id="authenticationCode" bind:value={authenticationCode} placeholder="Dein Freischaltungscode" type="password" required class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-accent-border sm:text-sm sm:leading-6" on:keydown={handleKeyDown}>
        </div>
        <Button on:click={handleLoginClick} className="w-full rounded-md" variant="submit">Einloggen</Button>
    </ContentBox>
</PageBox>
